import React, { useContext } from 'react';
import { ModuleSectionHeader, ModuleSectionRoot } from './ModuleSectionComponents';
import PrioritizationContext from 'pages/Zones/PrioritizationContext/PrioritizationContext';

import { FlightToggleSwitch } from '@flybits/design-system';

import { ReactComponent as Deprioritized } from 'assets/icons/deprioritize-content.svg';

import './DeprioritizedSection.scss';
import { Module } from 'pages/Zones/types';

type EnableDeprioritized = {
  sectionNumber: number;
  module: Module;
};
function EnableDeprioritized({ sectionNumber, module }: EnableDeprioritized) {
  const MAIN_CLASS = 'labeled-section';
  const { updateModule, selectedZone } = useContext(PrioritizationContext);
  const { contentSuppressionConfig } = module;
  const { deprioritize } = contentSuppressionConfig || {};
  const deprioritizeEnabled = !!deprioritize?.enabled;
  const handleOnChangeToggle = (newValue: boolean) =>
    selectedZone.id && updateModule(selectedZone.id, { ...module, contentSuppressionConfig: { deprioritize: { enabled: newValue, scope: deprioritize ? deprioritize.scope : 'all' } } });
  function LabeledAndOrderContentHeader() {
    return (
      <div className={`${MAIN_CLASS}`}>
        <ModuleSectionHeader
          icon={<Deprioritized />}
          title={'Enable deprioritize button'}
          subtext={
            <>
              Toggling this feature allows the user the option to defer the content. It will move to the end of the
              priority order. You can also set the content to disappear after an allotted time
            </>
          }
        />
        <FlightToggleSwitch
          className="deprioritized-section"
          checked={deprioritizeEnabled}
          onChange={handleOnChangeToggle}
        />
      </div>
    );
  }

  return (
    <ModuleSectionRoot sectionNumber={sectionNumber}>
      <LabeledAndOrderContentHeader />
    </ModuleSectionRoot>
  );
}

export default EnableDeprioritized;
